export const MINUTES_PER_SLOT = 15;
/** Default (static) pixels per slot — used by visual-builder and as fallback. */
export const PIXELS_PER_SLOT = 40;
export const PREVIEW_PIXELS_PER_SLOT = 50;
export const SLOTS_PER_HOUR = 60 / MINUTES_PER_SLOT;
export const TOTAL_SLOTS = 24 * SLOTS_PER_HOUR;
export const TIME_LABEL_WIDTH = 55;
export const HEADER_HEIGHT = 100;
export const COLUMN_RIGHT_MARGIN = 10;
export const MIN_COLUMN_WIDTH = 140;

/** Minimum visual duration (in minutes) for calendar events. */
export const MIN_EVENT_DURATION_MINUTES = 10;
/** Minimum visual duration in ms for layout/overlap calculations. */
export const MIN_EVENT_DURATION_MS = MIN_EVENT_DURATION_MINUTES * 60 * 1000;
/** Minimum pixel height for events on the main calendar. */
export const MIN_EVENT_HEIGHT_PX =
  (MIN_EVENT_DURATION_MINUTES / MINUTES_PER_SLOT) * PIXELS_PER_SLOT;
/** Minimum pixel height for events on the preview calendar. */
export const MIN_PREVIEW_EVENT_HEIGHT_PX =
  (MIN_EVENT_DURATION_MINUTES / MINUTES_PER_SLOT) * PREVIEW_PIXELS_PER_SLOT;

/** Returns minimum event height for a given pixelsPerSlot value. */
export const getMinEventHeightPx = (pxPerSlot: number): number =>
  (MIN_EVENT_DURATION_MINUTES / MINUTES_PER_SLOT) * pxPerSlot;

/**
 * For 10-min grid lines, the marks don't align with 15-min slot boundaries.
 * Returns the pixel offset within the slot for the 10-min mark.
 * - Even slots (0, 2): mark 10 min into slot
 * - Odd slots (1, 3): mark 5 min into slot
 */
export const getTenMinLineOffset = (
  nthSlotOfHour: number,
  pxPerSlot: number = PIXELS_PER_SLOT,
): number => {
  const minuteIntoSlot = nthSlotOfHour % 2 === 0 ? 10 : 5;
  return (minuteIntoSlot / MINUTES_PER_SLOT) * pxPerSlot;
};

// --- Dynamic pixel scaling based on average service duration ---

const MIN_PIXELS_PER_SLOT = 20;
const MAX_PIXELS_PER_SLOT = 60;
/** Target pixel height for an average-duration event. */
const TARGET_EVENT_HEIGHT_PX = 100;

/**
 * Compute the ideal pixels-per-slot so that an event whose duration equals
 * `avgDurationMinutes` renders at roughly TARGET_EVENT_HEIGHT_PX.
 */
export const computePixelsPerSlot = (avgDurationMinutes: number): number => {
  const raw = (TARGET_EVENT_HEIGHT_PX * MINUTES_PER_SLOT) / avgDurationMinutes;
  return Math.round(
    Math.min(MAX_PIXELS_PER_SLOT, Math.max(MIN_PIXELS_PER_SLOT, raw)),
  );
};
